<template>
  <div class="forums-index-header">
    <div class="forums-index-header__mural">
      <div
        v-for="row in 6"
        :key="row"
        class="forums-index-header__mural-row"
      >
        <div
          v-for="bubble in 5"
          :key="bubble"
          class="forums-index-header__mural-bubble"
          :class="`forums-index-header__mural-bubble--position-${bubble} forums-index-header__mural-bubble--${row}${bubble}`"
        >
          <div class="forums-index-header__mural-dots" />
        </div>
      </div>
    </div>
    <div class="forums-index-header__content">
      <h1
        class="forums-index-header__heading"
        data-test-id="forums-index-header-heading"
      >
        Forums
      </h1>
      <p
        class="forums-index-header__subtitle"
        data-test-id="forums-index-header-subtitle"
      >
        Read conversations, start a discussion,
        and connect with others about {{ this.$site.settings.condition_name }}.
      </p>
      <div class="forums-index-header__cta">
        <button
          class="forums-index-header__cta-button button"
          data-test-id="forums-index-header-cta-button"
          @click="handleCreateClick"
        >Start a discussion
        </button>
        <search-form
          class="forums-index-header__search"
          data-test-id="forums-index-header-search"
          placeholder="Search discussions"
          aria-label="Search discussions"
          :term="term"
          @search="handleSearch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SearchForm from '@/components/Search/SearchForm.vue';

export default {
  name: 'ForumsIndexHeader',
  components: {
    SearchForm,
  },
  props: {
    term: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleCreateClick() {
      this.$router.push({ name: 'createThread' });
    },
    handleSearch(term) {
      this.$emit('handleSearch', term);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_forums-index-header';
</style>
